exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning[data-v-16377441] {\n  background-color: #f9b34a;\n}\n.govuk-warning-text[data-v-16377441] {\n  margin-bottom: 0;\n}\n", ""]);

// exports
